<template>
    <div class="login-uk">
      <div class="gears">
        <h1>LOADING</h1>
      </div>
    </div>
</template>

<script>
import firebase from 'firebase/compat/app'

export default {
  name: 'Auth',
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    getURLParameter (name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.search
          ) || [null, ''])[1].replace(/\+/g, '%20')
        ) || null
      )
    },
    getFirebaseProjectId () {
      return firebase.app().options.authDomain.split('.')[0]
    },
    tokenReceived (data) {
      if (data.token) {
        firebase
          .auth()
          .signInWithCustomToken(data.token)
          .then((user) => {
            this.$router.replace('conferences')
          })
      } else {
        console.error(data)
        document.body.innerText =
            'Error in the token Function: ' + data.error
      }
    },
    checkURL () {
      var code = this.getURLParameter('code')
      var state = this.getURLParameter('state')
      var error = this.getURLParameter('error')
      if (error) {
        document.body.innerText =
        'Error back from the Azure AD auth page: ' + error
      } else if (!code) {
        // Start the auth flow.
        window.location.href =
            'https://us-central1-' +
            this.getFirebaseProjectId() +
            '.cloudfunctions.net/redirect'
      } else {
        // Use JSONP to load the 'token' Firebase Function to exchange the auth code against a Firebase custom token.
        const script = document.createElement('script')
        script.type = 'text/javascript'
        // This is the URL to the HTTP triggered 'token' Firebase Function.
        // See https://firebase.google.com/docs/functions.
        var tokenFunctionURL =
            'https://us-central1-' +
            this.getFirebaseProjectId() +
            '.cloudfunctions.net/token'
        script.src =
            tokenFunctionURL +
            '?code=' +
            encodeURIComponent(code) +
            '&state=' +
            encodeURIComponent(state) +
            '&callback=tokenReceiving'
        document.head.appendChild(script)
      }
    }
  },
  beforeMount () {
    this.checkURL()
  },
  mounted () {
    var code = this.getURLParameter('code')
    var state = this.getURLParameter('state')
    var tokenFunctionURL =
            'https://us-central1-' +
            this.getFirebaseProjectId() +
            '.cloudfunctions.net/token'
    var src =
            tokenFunctionURL +
            '?code=' +
            encodeURIComponent(code) +
            '&state=' +
            encodeURIComponent(state)
    this.$jsonp(src, {
      callbackName: 'tokenReceiving'
    }).then(json => {
      this.tokenReceived(json)
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>
<style scoped>
.login-uk {
   position:fixed;
   padding:0;
   margin:0;
   width: 100%;
   height: 100%;
   background: #82b7bb
}
.gears {
   width: 350px;
   margin: 100px auto;
   display: block;
   text-align: center;
   font-weight: bold;
   font-family: Arial;
   color: #fff;
   text-shadow: 1px 1px 2px #5F868A
}
.gears .big {
   width: 100px;
   height: 100px;
   -webkit-transform-origin: center;
   -moz-transform-origin: center;
   -o-transform-origin: center;
   transform-origin: center;
   -webkit-animation: rotate 1.5s linear infinite;
   -moz-animation: rotate 1.5s linear infinite;
   -o-animation: rotate 1.5s linear infinite;
   animation: rotate 1.5s linear infinite
}
.gears .small {
   width: 70px;
   height: 70px;
   margin-left: -6px;
   -webkit-transform-origin: center;
   -moz-transform-origin: center;
   -o-transform-origin: center;
   transform-origin: center;
   -webkit-animation: reverseRotate 1.5s linear infinite;
   -moz-animation: reverseRotate 1.5s linear infinite;
   -o-animation: reverseRotate 1.5s linear infinite;
   animation: reverseRotate 1.5s linear infinite;
}
@-webkit-keyframes rotate {
   0% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
   }
   100% {
      -webkit-transform: rotate(180deg);
      transform: rotate(180deg);
   }
}
@-moz-keyframes rotate {
   0% {
      -moz-transform: rotate(0);
      transform: rotate(0);
   }
   100% {
      -moz-transform: rotate(180deg);
      transform: rotate(180deg);
   }
}
@-o-keyframes rotate {
   0% {
      -o-transform: rotate(0);
      transform: rotate(0);
   }
   100% {
      -o-transform: rotate(180deg);
      transform: rotate(180deg);
   }
}
@keyframes rotate {
   0% {
      -webkit-transform: rotate(0);
      -moz-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
   }
   100% {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      transform: rotate(180deg);
   }
}
@-webkit-keyframes reverseRotate {
   0% {
      -webkit-transform: rotate(180deg);
      transform: rotate(180deg);
   }
   100% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
   }
}
@-moz-keyframes reverseRotate {
   0% {
      -moz-transform: rotate(180deg);
      transform: rotate(180deg);
   }
   100% {
      -moz-transform: rotate(0);
      transform: rotate(0);
   }
}
@-o-keyframes reverseRotate {
   0% {
      -o-transform: rotate(180deg);
      transform: rotate(180deg);
   }
   100% {
      -o-transform: rotate(0);
      transform: rotate(0);
   }
}
@keyframes reverseRotate {
   0% {
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      transform: rotate(180deg);
   }
   100% {
      -webkit-transform: rotate(0);
      -moz-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
   }
}
</style>



// WEBPACK FOOTER //
// src/components/Auth.vue